import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { BrowserRouter as Router } from 'react-router-dom'
import { useSelector } from 'react-redux'

import AppHeader from '../AppControl/AppHeader'
import AppSidebar from '../AppControl/AppSidebar'
import PageHandler from '../AppControl/PageHandler'
import Routes from '../../navigation/Routes'
import { isLoggedIn, getUser, getMultiTab } from '../../redux/global'
import doLogin from '../Login'
import { UpdateDistrict } from './DashBoard/Cards/UpdateDistrict'
import Alert from '@mui/material/Alert'
import { t } from 'i18next'

const AppContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

const AppMiddle = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  overflow: auto;
`

export default () => {
  const [userLoggedIn, setUserLoggedIn] = useState(false)
  const loggedIn = useSelector(isLoggedIn)
  const { district } = getUser()

  const [tabWarnEnable, setTabWarnEnable] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      if (getMultiTab()) {
        setTabWarnEnable(true)
      }
    }, 3000)
  }, [])
  useEffect(() => {
    setUserLoggedIn(loggedIn)
    if (!loggedIn) {
      setTimeout(doLogin, 1)
    }
  }, [loggedIn])

  if (!userLoggedIn) {
    return <AppHeader userLoggedIn={userLoggedIn} id='AppHeader' />
  }

  return (
    <Router>
      <AppContainer>
        <AppHeader userLoggedIn={userLoggedIn} id='AppHeader' />
       
        {tabWarnEnable && 
          <Alert variant="filled" severity="error" sx={{ '& .MuiAlert-message': { fontSize: '0.9vw' }, marginTop: '-3px', borderRadius: '0px' }}>
            {t('messages.attention')} {t('messages.attentionMsg')}
          </Alert>
        }
        <AppMiddle id='AppMiddle'>
          <AppSidebar />
          <PageHandler>
            {(district !== '' && district !== null && district !== undefined && district !== 'undefined') 
              ? <Routes /> 
              : <UpdateDistrict IsloginWithoutDistrict = {false} ></UpdateDistrict>}
          </PageHandler>
        </AppMiddle>
      </AppContainer>
    </Router>
  )
}
